import { ENGAGEMENT_DETAILS_MESSAGE } from '../constants/engagementDetailsMessageType';

//@ts-expect-error file not typed
import { getTopLevelType } from '../../common-message-format/operators/commonMessageFormatGetters';
export const isEngagementDetailsMessage = message => {
  return getTopLevelType(message) === ENGAGEMENT_DETAILS_MESSAGE;
};